import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
/**
 * 日付をフォーマットする
 * @param value
 * @param format
 * @returns
 */
export const dateFormat = (value: string | number, format = "YYYY/MM/DD") => {
  return dayjs(value).format(format);
};

/**
 * ミリ秒から日付をフォーマットする
 * @param milliseconds ミリ秒
 * @returns yyyy/mm/dd
 */
export const formatDateFromMilliseconds = (milliseconds: string, format = "YYYY/MM/DD"): string => {
  const seconds = parseInt(milliseconds) / 1000;
  return dayjs.unix(seconds).format(format);
};
